<div class="row" *ngIf="isBasica || isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Vermelha</mat-label>
                                <mat-select #txtFxVermelha formControlName="Faixa_vermelha" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxVermelha($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsFxVermelho" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_vermelha)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Roxa
                                </mat-label>
                                <mat-select #txtFxRoxa formControlName="Faixa_roxa" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxRoxa($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsFxRoxa" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_roxa)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>


<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Vermelha
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <mat-select #txtFxVermelha formControlName="Faixa_vermelha" disableCenteringOption>
                                    <input matInput type="text" required class="form-control">
                                    <mat-option *ngFor="let item of listOptionsFxVermelho" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_vermelha)}}</mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>